import { Dispatch } from 'redux';
import {
  LOADING_FAILURE,
  LOADING_REQUEST,
  LOADING_SUCCESS
} from '../../../../../core/redux/types/loading-types';
import { UserRepositoryImpl } from '../../../data/repositories/user-repository-impl';
import { UserUsecaseImpl } from '../../../domain/usecases/user-usecase';

import { USER_LOAD_REQUEST, USER_LOAD_SUCCESS, USER_LOAD_FAILURE } from '../types/user-types';
import {
  USERS_LOAD_REQUEST,
  USERS_LOAD_SUCCESS,
  USERS_LOAD_FAILURE,
  USERS_UPDATE_USER
} from '../types/users-types';

export const createUserAction = (
  name: string,
  email: string,
  mobile_no: string,
  password: string,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: USER_LOAD_REQUEST });

    try {
      const userRepository = new UserRepositoryImpl();
      const userUsecase = new UserUsecaseImpl(userRepository);

      const result = await userUsecase.CreateUser(name, email, mobile_no, password);

      dispatch({ type: USER_LOAD_SUCCESS, payload: result });
      props.history.push('/users');
    } catch (error) {
      // console.log(error.message);
      dispatch({ type: USER_LOAD_FAILURE, error });
    }
  };
};

export const getUsersAction = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: USERS_LOAD_REQUEST });

    try {
      const userRepository = new UserRepositoryImpl();
      const userUsecase = new UserUsecaseImpl(userRepository);

      const result = await userUsecase.GetUsers();

      dispatch({ type: USERS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: USERS_LOAD_FAILURE, error });
    }
  };
};

export const editUserAction = (
  user_id: string,
  name: string,
  email: string,
  mobile_no: string,
  props: any
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const userRepository = new UserRepositoryImpl();
      const userUsecase = new UserUsecaseImpl(userRepository);

      const result = await userUsecase.EditUser(user_id, name, email, mobile_no);

      dispatch({ type: USER_LOAD_SUCCESS, payload: result });
      dispatch({ type: USERS_UPDATE_USER, user: result });
      dispatch({ type: LOADING_SUCCESS });
      props.handleClose();
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error: error });
    }
  };
};

export const getUserAction = (user_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: USER_LOAD_REQUEST });

    try {
      const userRepository = new UserRepositoryImpl();
      const userUsecase = new UserUsecaseImpl(userRepository);

      const result = await userUsecase.GetUser(user_id);

      dispatch({ type: USER_LOAD_SUCCESS, payload: result });
    } catch (error) {
      // console.log(error.message);
      dispatch({ type: USER_LOAD_FAILURE, error });
    }
  };
};

export const editUserPasswordAction = (user_id: string, password: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });

    try {
      const userRepository = new UserRepositoryImpl();
      const userUsecase = new UserUsecaseImpl(userRepository);

      const result = await userUsecase.EditUserPassword(user_id, password);

      dispatch({ type: USER_LOAD_SUCCESS, payload: result });
      dispatch({ type: LOADING_SUCCESS });
      props.handleClose();
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error });
    }
  };
};
